import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

const UserService = {
    getUsers: async function() {
        const response = await axios.get(`${API_URL}/users`, null, {
            crossDomain: true,
        });
        return response.data;
    },

    getUser: async function(id) {
        const response = await axios.get(`${API_URL}/users`, null, {
            params: {
                id
            },
            crossDomain: true,
        });
        return response.data;
    }
};

export default UserService;